import {
  Avatar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography
} from "@mui/material";
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import React from "react";
import Section from "./Section";
function Footer({ }) {
  return (<>
    <Section>
      <Container maxWidth="md" sx={{
        marginBottom: 3,
      }}>
        <Typography variant="h5" gutterBottom fontWeight='bold'>
          Zapraszam do kontaktu
        </Typography>
        <Toolbar disableGutters
          sx={{
            justifyContent: { xs: "left", sm: 'space-between' },
          }}
        >
          <Button
            startIcon={<Avatar> <MailOutlineSharpIcon /></Avatar>}
            href="mailto:natalia@sawicka.pro?subject=Zapytanie"
          >
            <Typography variant='subtitle2'
              sx={{
                display: { xs: "none", sm: "flex" },
              }}>
              natalia@sawicka.pro
            </Typography>
          </Button>
          <Button 
            startIcon={<Avatar><CallOutlinedIcon /></Avatar>}
            href="tel:+48726849319"
          >
            <Typography variant='subtitle2'
              sx={{
                display: { xs: "flex", sm: "flex" },
              }}>
              726 849 319
            </Typography>
          </Button>
        </Toolbar>
      </Container>
    </Section>
  </>
  );
}

export default Footer;
